import React from 'react';
import { FaPhone, FaEnvelope, FaClock, FaGlobe, FaMapMarkerAlt } from 'react-icons/fa';
import { CONTACT, phoneHref } from '../constants/contact';
import './ContactDetails.css';

const ContactDetails = ({ className = '', compact = false }) => {
  const items = [
    {
      icon: FaPhone,
      label: 'Phone',
      value: CONTACT.phone,
      href: phoneHref,
    },
    {
      icon: FaEnvelope,
      label: 'Email',
      value: CONTACT.email,
      href: `mailto:${CONTACT.email}`,
    },
    {
      icon: FaMapMarkerAlt,
      label: 'Address',
      lines: [CONTACT.company, CONTACT.addressLine1, CONTACT.addressLine2],
    },
    {
      icon: FaGlobe,
      label: 'Website',
      value: CONTACT.website,
      href: CONTACT.websiteUrl,
      external: true,
    },
    {
      icon: FaClock,
      label: 'Hours',
      lines: [CONTACT.hoursWeekdays, CONTACT.hoursSaturday],
    },
  ];

  return (
    <div className={`contact-details ${compact ? 'contact-details--compact' : ''} ${className}`.trim()}>
      <h3 className="contact-details-title">Contact Details</h3>
      <div className="contact-details-grid">
        {items.map(({ icon: Icon, label, value, href, external, lines }) => (
          <div className="contact-details-item" key={label}>
            <div className="contact-details-icon">
              <Icon />
            </div>
            <div>
              <span className="contact-details-label">{label}</span>
              {lines ? (
                lines.map((line) => <span key={line} className="contact-details-value">{line}</span>)
              ) : (
                <a
                  href={href}
                  className="contact-details-value contact-details-link"
                  target={external ? '_blank' : undefined}
                  rel={external ? 'noreferrer' : undefined}
                >
                  {value}
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactDetails;
